import { render, staticRenderFns } from "./RutaIndex.vue?vue&type=template&id=6637a524"
import script from "./RutaIndex.vue?vue&type=script&lang=js"
export * from "./RutaIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports